// extracted by mini-css-extract-plugin
export default {"appButton":"AppButton_appButton__9gCJf","TEXT":"AppButton_TEXT__rcxgb","PRIMARY":"AppButton_PRIMARY__2iyrF","clicked":"AppButton_clicked__JYXZZ"};